import { render, staticRenderFns } from "./SplitTestContainer.vue?vue&type=template&id=1b0ea220&scoped=true&"
import script from "./SplitTestContainer.vue?vue&type=script&lang=js&"
export * from "./SplitTestContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ea220",
  null
  
)

export default component.exports